import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';
import { data } from '../_models';
import { UserService, AuthenticationService } from '../_services';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {

  isdata: boolean = false
  currentdata: data;
  currentdataSubscription: Subscription;
  datas: data[] = [];

  constructor(
      private authenticationService: AuthenticationService,
      private UserService: UserService,
      private router: Router
  ) {
      this.currentdataSubscription = this.authenticationService.currentdata.subscribe(data => {
          this.currentdata = data;
          this.authenticationService.currentdata.subscribe(x => this.currentdata = x);

      });
  }
 
  ngOnInit() {
      // this.loadAlldatas();
  }

  ngOnDestroy() {
      // unsubscribe to ensure no memory leaks
      this.currentdataSubscription.unsubscribe();
  }

  deletedata(id: number) {
      this.UserService.delete(id).pipe(first()).subscribe(() => { 
          this.loadAlldatas()
      });
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/home']);
}

  private loadAlldatas() {
      this.UserService.getAll().pipe(first()).subscribe(datas => {
          this.datas = datas;
      });
  }
}